import { ReactNode } from "react"
import {
  Dialog as HeadlessDialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from "@headlessui/react"
import { clsx } from "clsx"

import { IconButton } from "@src/components/atoms/IconButton"

export type DialogProps = {
  title?: string
  open: boolean
  onClose: () => void
  children: ReactNode
  actions?: ReactNode
  size?: "small" | "medium" | "large"
}

export const Dialog = ({
  title,
  open,
  onClose,
  children,
  actions,
  size = "medium",
}: DialogProps) => {
  return (
    <HeadlessDialog
      open={open}
      onClose={onClose}
      className="fixed inset-0 z-50"
    >
      <DialogBackdrop className="fixed inset-0 bg-black/30 backdrop-blur-sm" />

      <DialogPanel
        className={clsx([
          "fixed left-1/2 top-1/2 max-h-[100vh] w-10/12 -translate-x-1/2 -translate-y-1/2 overflow-y-auto",
          "rounded-xl bg-white shadow-lg",
          size === "small" && "lg:w-1/2 lg:min-w-[520px] lg:max-w-[520px]",
          size === "medium" && "lg:w-1/2 lg:min-w-[800px] lg:max-w-[800px]",
          size === "large" && "lg:w-3/4",
        ])}
      >
        {title && (
          <DialogTitle className="flex items-center justify-between border-b border-pearl-lighter p-4 text-paragraph font-semibold text-black-light">
            {title}
          </DialogTitle>
        )}

        <IconButton
          icon="close"
          onClick={onClose}
          className="absolute right-4 top-4 z-10 text-paragraph"
          variant="ternary"
        />

        <div>
          {children && <div className="p-4">{children}</div>}
          {actions && (
            <div className="bg-pearl-lighter/15 px-4 py-2">{actions}</div>
          )}
        </div>
      </DialogPanel>
    </HeadlessDialog>
  )
}
